import type { JSX } from "react";
import { createElement, forwardRef } from "react";
import type { ViewProps } from "@/components/types";

const View = forwardRef<HTMLElement, ViewProps>(
  ({ children, type = "div", ...props }, ref): JSX.Element =>
    createElement(type, { ...props, ref }, children)
);

View.displayName = "View";

export default View;
